import { ModelService } from 'app/model/services/model.service';
import { IAttribute, IViolation } from './annotation';
import { Metamodel } from 'app/model/base/model';

import { IAttributeValidator, IValidationContext } from 'shell-models-lib';
import { Named, Owned } from './named';
import { getServiceInstance } from 'app/multi-contexts/modules/root/root.application';

export class UniqueModelNameValidator implements IAttributeValidator {
    public static readonly INSTANCE = new UniqueModelNameValidator();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public async validate(_object: {}, attribute: IAttribute, value: string, _owner: Owned, context: IValidationContext): Promise<IViolation[] | undefined> {
        const modelService = await getServiceInstance<ModelService>(context.contextData, 'ModelService');
        const violations: IViolation[] = [];
        const isUnique = modelService.isUniqueName(value, Metamodel.modelOf(_object), _object as Named);
        if (!isUnique) {
            violations.push({
                context: _object,
                message: () => stringResources.Validator_ErrorMessage_Unique,
                attributes: [attribute]
            });
        }
        return violations;
    }
}
